<template>
  <div>
    <span v-if="recentResults.length">
      Recent results:
      <b v-tooltip="'Percentage of passing API calls'" class="color-pass"
        >{{ (100 * recentPassPct).toFixed(1) }}%</b
      >
      /
      <b v-tooltip="'Percentage of API calls with a warning'" class="color-warn"
        >{{ (100 * recentWarnPct).toFixed(1) }}%</b
      >
      /
      <b v-tooltip="'Percentage of failing API calls'" class="color-fail"
        >{{ (100 * recentFailPct).toFixed(1) }}%</b
      >
      |
    </span>
    <span>
      <span
        v-if="totalApis"
        v-tooltip="'Cloud API Service Consitency is calculated once per week every Monday'"
        ><b>{{ totalApis }}</b> Projects with CASC scores
      </span>
      <span v-if="totalApis">
        :
        <span
          v-tooltip="'A CASC score of 8.00 or higher means the API is healthy'"
          class="color-pass"
        >
          <b>{{ goodApis }}</b> ({{ ((goodApis / totalApis) * 100).toFixed(0) }}%) HEALTHY
        </span>
        /
        <span
          v-tooltip="'A CASC score 6.00 to 8.00 means the API has some issues'"
          class="color-warn"
        >
          <b>{{ okayApis }}</b> ({{ ((okayApis / totalApis) * 100).toFixed(0) }}%) ISSUES
        </span>
        /
        <span
          v-tooltip="'A CASC score below 6.00 means the API is of serious concern'"
          class="color-fail"
        >
          <b>{{ badApis }}</b> ({{ ((badApis / totalApis) * 100).toFixed(0) }}%) CONCERN
        </span>
      </span>
    </span>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import _flatten from 'lodash/flatten';
import _groupBy from 'lodash/groupBy';

export default {
  name: 'ProjectHeadlines',
  props: {
    sortedData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    recentPassPct() {
      return (this.recentResultsGrouped.PASS || []).length / this.recentResults.length;
    },
    recentWarnPct() {
      return (this.recentResultsGrouped.WARNING || []).length / this.recentResults.length;
    },
    recentFailPct() {
      return (this.recentResultsGrouped.FAIL || []).length / this.recentResults.length;
    },
    recentResultsGrouped() {
      return _groupBy(this.recentResults, 'meta.result_category');
    },
    recentResults() {
      const anHourAgo = moment.utc().add(-1, 'hours');
      const justResults = this.sortedData.map(({ results }) => results);
      const flattened = _flatten(justResults);
      const filtered = flattened.filter(
        (res) => res && res.meta && moment.utc(res.meta.start_time) > anHourAgo,
      );
      return filtered;
    },
    totalApis() {
      return this.sortedData.filter(({ synopsis }) => synopsis?.insights).length;
    },
    goodApis() {
      return this.sortedData.filter(({ synopsis }) => synopsis?.insights?.score >= 800).length;
    },
    okayApis() {
      return this.sortedData.filter(
        ({ synopsis }) => synopsis?.insights?.score < 800 && synopsis?.insights?.score >= 600,
      ).length;
    },
    badApis() {
      return this.sortedData.filter(({ synopsis }) => synopsis?.insights?.score < 600).length;
    },
  },
};
</script>
